import { Navigate, Outlet } from 'react-router-dom';
import { useApplicantStore } from './applicantStore';

export const RequireApplicant = () => {
  const token = useApplicantStore((s) => s.token);
  if (!token) return <Navigate to="/apply/signup" replace />;
  return <Outlet />;
};
